import React from 'react';
import packageJson from '../../package.json';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="text-sm text-gray-500">
            Running on SkidsUp Software © 2024–2026 Fernie Consulting Group LLC
          </div>
          <div className="text-sm text-gray-500">
            v{packageJson.version}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;